module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-menu-331b54317f267d7e6ebfd4228bdaa45a.svg";